import React from 'react';
import './PageHero.css';

// Shared header for every non-home page. Keeps the ambient treatment of the
// home hero (grid + drifting orb) at roughly a third of the height, so inner
// pages feel part of the same site without burning a full screen on a title.
//
//   <PageHero eyebrow="Work" title="Live Apps" lede="…" meta={['8 shipped']}>
//     <Link className="btn btn--primary">…</Link>
//   </PageHero>

const PageHero = ({ eyebrow, title, lede, meta, children, align = 'left' }) => (
  <header className={`page-hero page-hero--${align}`}>
    <div className="page-hero-grid" aria-hidden="true" />
    <div className="page-hero-orb" data-parallax="0.06" aria-hidden="true" />

    <div className="container page-hero-inner">
      {eyebrow && <p className="eyebrow reveal reveal-fade">{eyebrow}</p>}

      <h1 className="page-hero-title">
        <span className="reveal-mask">
          <span>{title}</span>
        </span>
      </h1>

      {lede && (
        <p className="page-hero-lede reveal reveal-up" style={{ '--reveal-delay': '0.14s' }}>
          {lede}
        </p>
      )}

      {meta && meta.length > 0 && (
        <ul className="page-hero-meta reveal reveal-up" style={{ '--reveal-delay': '0.2s' }}>
          {meta.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )}

      {children && (
        <div
          className="page-hero-actions btn-row reveal reveal-up"
          style={{ '--reveal-delay': '0.26s' }}
        >
          {children}
        </div>
      )}
    </div>
  </header>
);

export default PageHero;
